export default __webpack_public_path__ + "6dec9bba74e488f8f56c73f4e4adf8dc.png";